import React, { useRef, useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input, styled } from "@mui/material";
import { Button } from "../Button/Button";
import { useArrowKeyFocus } from "../Hooks/useArrowKeyFocus/useArrowKeyFocus";
const classes = {
    listBox: "listBox-listBox",
    listBoxItem: "listBox-listBoxItem",
    listBoxItemContent: "listBox-listBoxItemContent",
    listBoxInput: "listBox-listBoxInput",
    listBoxItemDeleteButton: "listBox-listBoxItemDeleteButton",
    listBoxText: "listBox-listBoxText"
};
const StyledDiv = styled("div")(({ theme }) => ({
    [`& .${classes.listBox}`]: {},
    [`& .${classes.listBoxItem}`]: {
        display: "flex",
        flexDirection: "row",
        paddingTop: "10px",
        paddingLeft: "10px"
    },
    [`& .${classes.listBoxItemContent}`]: {
        flex: "1 1 auto",
        fontSize: "14px",
        borderBottom: `1px solid ${theme.palette.controls.input.border.main}`,
        paddingLeft: "9px"
    },
    [`& .${classes.listBoxInput}`]: {
        display: "block",
        fontSize: "14px",
        width: "100%"
    },
    [`& .${classes.listBoxItemDeleteButton}`]: {
        flex: "0 0 auto",
        marginLeft: "15px",
        marginRight: "15px",
        fontSize: "1.2em"
    }
}));
function ListBoxItem(props) {
    const [newText, setNewText] = useState(props.content);
    const inputText = useRef(null);
    const updateText = () => {
        if (props.onChange) {
            props.onChange(newText);
        }
    };
    const onChange = (event) => {
        const text = event.target.value;
        setNewText(text);
    };
    const listboxContent = props.onChange ? (React.createElement(Input, { className: `${classes.listBoxInput}`, value: newText, inputRef: inputText, onChange: onChange, onFocus: props.onFocus, autoFocus: props.autoFocus })) : (React.createElement("div", { className: `${classes.listBoxText}` }, props.content));
    useEffect(() => {
        if (props.focus) {
            inputText.current?.focus();
        }
    }, [props.focus]);
    const closeIcon = props.onChange ? (React.createElement(Button, { className: `${classes.listBoxItemDeleteButton}`, rounded: true, onClick: () => {
            props.onChange("");
        }, variant: "plain", iconButton: true, startIcon: React.createElement(CloseIcon, null), "aria-label": `delete ${props.content}` })) : null;
    return (React.createElement("div", { className: `${classes.listBoxItem}` },
        React.createElement("div", { className: `${classes.listBoxItemContent}`, onBlur: updateText }, listboxContent),
        closeIcon));
}
export function ListBox(props) {
    const listBoxRef = useRef(null);
    const { focusIndex, onItemFocus, onContainerBlur } = useArrowKeyFocus(props.contents.length, listBoxRef);
    const listItems = props.contents.map((content, index) => {
        return (React.createElement(ListBoxItem, { key: `${index} ${content}`, content: content, onChange: props.readonly
                ? undefined
                : (value) => {
                    props.onChange(value.trim() === ""
                        ? [...props.contents.slice(0, index), ...props.contents.slice(index + 1)]
                        : [...props.contents.slice(0, index), value, ...props.contents.slice(index + 1)]);
                }, focus: focusIndex === index, onFocus: () => onItemFocus(index), autoFocus: index === 0 && props.autoFocus ? true : false }));
    });
    return (React.createElement(StyledDiv, { className: `${classes.listBox}`, style: props.style, ref: listBoxRef, onBlur: onContainerBlur }, listItems));
}
//Prop defaults
ListBox.defaultProps = {
    autoFocus: false
};
